<template>
  <div>
    <el-form role="form" @submit.prevent.native="onSubmit">
      <div class="row">
        <div class="col-md-6">
          <base-input label="Name" v-model="productUnit.label" v-uppercase></base-input>
        </div>
        <div class="col-md-6">
          <base-input label="Code" v-model="code"></base-input>
        </div>
      </div>
      <base-button md type="primary" native-type="submit">Save</base-button>
    </el-form>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { Form } from "element-ui";
export default {
  directives: {
    uppercase: {
      inserted: function(el, _, vnode) {
        el.addEventListener("input", async function(e) {
          const modified = e.target.value
            .split(" ")
            .map(i => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      }
    }
  },
  data: () => {
    return {};
  },

  computed: {
    ...mapState("product", ["productUnit"]),
    code: {
      get() {
        return this.productUnit.label
          .split(" ")
          .join("_")
          .toLowerCase();
      },
      set(value) {
        return value;
      }
    }
  },
  components: {
    [Form.name]: Form
  },

  methods: {
    ...mapActions({
      saveProductUnit: "product/saveProductUnit",
      updateProductUnit: "product/updateProductUnit",
      getProductUnits: "product/getProductUnits"
    }),
    onSubmit() {
      if (this.productUnit.productUnitId) {
        this.productUnit.code = this.code;
        this.updateProductUnit().then(res => {
          this.$notify({
            message: "Product Unit Updated Succesfully!",
            type: "success",
            title: "Succes"
          });
          this.getProductUnits();
          this.$emit("close");
        });
      } else {
        this.productUnit.code = this.code;
        this.saveProductUnit().then(res => {
          this.$notify({
            message: "Product Unit Saved Succesfully!",
            type: "success",
            title: "Success"
          });
          this.getProductUnits();
          this.$emit("close");
        });
      }
    }
  }
};
</script>